import { Injectable } from '@angular/core';
import { catchAndContinue, filterUndefined } from 'src/app/lego-utils';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { UnitsOfMeasure } from 'src/app/models/domain';
import { UnitsOfMeasureDataService } from 'src/app/services';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';
import { DesignService } from 'src/app/state/design.service';

@Injectable({
  providedIn: 'root',
})
export class UnitsOfMeasureService {
  private readonly state = new CollectionState<UnitsOfMeasure>();

  public readonly unitsOfMeasure$ = this.state.items$;
  public readonly error$ = this.state.error$;

  /** Only ready once the design it hangs off has loaded. */
  public readonly loading$: Observable<boolean> = combineLatest([
    this.designService.loading$,
    this.state.loading$,
  ]).pipe(map(([designLoading, uomLoading]) => designLoading || uomLoading));

  public constructor(
    private readonly designService: DesignService,
    private readonly unitsOfMeasureDataService: UnitsOfMeasureDataService
  ) {}

  public loadByDesignId() {
    return this.designService.selectDesignId().pipe(
      filterUndefined(() => {
        this.state.reset();
      }),
      tap(() => {
        this.state.setLoading(true);
      }),
      switchMap((designId) =>
        catchAndContinue(
          this.unitsOfMeasureDataService.getUnitsOfMeasuresByDesignId(designId),
          (error) => {
            handleError(this.state, error);
          }
        )
      ),
      tap((unitsOfMeasures) => {
        this.state.set(unitsOfMeasures);
      }),
      map(() => undefined)
    );
  }

  public reset() {
    this.state.reset();
  }
}
